type AlpInvestEntitlementFund = {
  productSegment: string;
};

/** Carlyle AlpInvest reporting funds — segment-based. */
export const isAlpInvestReportingEntitledFund = (fund: AlpInvestEntitlementFund): boolean =>
  fund.productSegment === "Carlyle AlpInvest";
